module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Regional-Landing-Page.3f4f8006.webp";